/* Shared product form controller for both brand presentations. */
(function () {
  'use strict';
  function wire(dataNode) {
    if (dataNode.__wired) return;
    var data;
    try { data = JSON.parse(dataNode.textContent); } catch (e) { return; }
    var root = document.getElementById(data.rootId), variants = data.variants;
    if (!root) return;
    dataNode.__wired = true;
    var form = root.querySelector('.zp-form');
    if (!form) return;
    var quantity = form.querySelector('[name="quantity"]');
    var plans = form.querySelector('[data-zp-plans]');
    function variant() { var input = form.querySelector('[name="id"]:checked') || form.querySelector('[data-zp-variant-single]'); return variants.find(function (v) { return input && String(v.id) === input.value; }); }
    function plan() { var input = form.querySelector('[name="selling_plan"]:checked'); return input ? input.value : ''; }
    function selectedPrice(v) { var selected = v.plans.find(function (p) { return String(p.id) === plan(); }); return selected ? selected.price : v.price; }
    function rebuildPlans(v) {
      if (!plans) return;
      var previous = plan();
      plans.replaceChildren();
      var choices = v.plans.slice();
      if (!v.requiresPlan) choices.push({ id: '', name: 'One-time purchase', price: v.price });
      var chosen = choices.some(function (p) { return String(p.id) === previous; }) ? previous : (v.requiresPlan && choices[0] ? String(choices[0].id) : '');
      choices.forEach(function (p) {
        var label = document.createElement('label'); label.className = 'zp-plan';
        var input = document.createElement('input'); input.type = 'radio'; input.name = 'selling_plan'; input.className = 'zp-visually-hidden'; input.value = p.id; input.checked = String(p.id) === chosen;
        var title = document.createElement('span'); title.className = 'zp-plan-title'; title.textContent = p.name;
        var price = document.createElement('span'); price.className = 'zp-plan-sub'; price.textContent = window.zpMoney(p.price);
        label.append(input, title, price); plans.appendChild(label);
      });
      plans.hidden = !v.plans.length;
    }
    function refresh() {
      var v = variant(); if (!v) return;
      var qty = Math.max(1, Math.floor(Number(quantity.value) || 1)); quantity.value = qty;
      root.querySelectorAll('[data-zp-total]').forEach(function (el) { el.textContent = window.zpMoney(selectedPrice(v) * qty); });
      root.querySelectorAll('[data-zp-price]').forEach(function (el) { el.textContent = window.zpMoney(v.price); });
      root.querySelectorAll('[data-zp-subtitle]').forEach(function (el) { el.textContent = v.title; });
      var available = v.available && (!v.requiresPlan || !!plan());
      root.querySelectorAll('[data-zp-add], [data-zp-sticky-add]').forEach(function (el) { el.disabled = !available; });
      var sticky = root.querySelector('[data-zp-sticky-add]'); if (sticky) sticky.textContent = available ? 'Add to cart' : 'Unavailable';
    }
    form.addEventListener('change', function (event) {
      var v = variant(); if (!v) return;
      if (event.target.name === 'id') {
        rebuildPlans(v);
        var image = root.querySelector('.zp-gallery-main img');
        if (image && v.mediaSrc) { image.removeAttribute('srcset'); image.src = v.mediaSrc; }
        root.querySelectorAll('[data-zp-thumb]').forEach(function (el) { el.classList.toggle('is-active', el.getAttribute('data-media-id') === String(v.mediaId)); });
        var u = new URL(window.location.href); u.searchParams.set('variant', v.id); history.replaceState(history.state, '', u);
      }
      refresh();
    });
    root.querySelector('[data-zp-dec]').addEventListener('click', function () { quantity.value = Math.max(1, Number(quantity.value) - 1); refresh(); });
    root.querySelector('[data-zp-inc]').addEventListener('click', function () { quantity.value = Number(quantity.value) + 1; refresh(); });
    form.addEventListener('submit', function (event) {
      var v = variant(); if (!v || !window.zpAddToCart) return;
      event.preventDefault(); refresh();
      if (!form.reportValidity() || !v.available || (v.requiresPlan && !plan())) return;
      window.zpAddToCart(v.id, Number(quantity.value), plan(), event.submitter || form.querySelector('[data-zp-add]'));
    });
    var cross = root.querySelector('[data-zp-cross-add]');
    if (cross) cross.addEventListener('click', function () {
      var v = variant(); if (!v || !v.available || (v.requiresPlan && !plan())) return;
      refresh();
      var item = { id: v.id, quantity: Number(quantity.value) }; if (plan()) item.selling_plan = plan();
      window.zpAddItems([item, { id: cross.getAttribute('data-cross-id'), quantity: 1 }], cross);
    });
    refresh();
  }
  function init() { document.querySelectorAll('[data-zp-product-data]').forEach(wire); }
  init(); document.addEventListener('shopify:section:load', init);
  /* A deferred brand section (theme.liquid) can arrive after load. */
  document.addEventListener('brand:defer:open', init);
})();
